package fr.frux.feature.treelist

import androidx.compose.runtime.Composable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.lifecycle.viewmodel.compose.viewModel

/** Contrat de fabrique du [TreeListViewModel], honoré par le composition root (#43). */
fun interface TreeListViewModelFactory {
    fun create(origin: TreeListOrigin): TreeListViewModel
}

/** Fabrique installée par le composition root ; sans défaut, pour que l'oubli de câblage crie. */
val LocalTreeListViewModelFactory =
    staticCompositionLocalOf<TreeListViewModelFactory> {
        error("TreeListViewModelFactory absente : le composition root doit l'installer (cf. FruxCompositionRoot, #43)")
    }

/** Fabrique le TreeListViewModel depuis la fabrique fournie par le root. */
@Composable
fun rememberTreeListViewModel(origin: TreeListOrigin): TreeListViewModel {
    val factory = LocalTreeListViewModelFactory.current
    return viewModel { factory.create(origin) }
}
